import React, { useState, useEffect } from 'react';
import { Check, X, CheckCircle, User, MessageSquare, AlertTriangle } from 'lucide-react';
import { BotonCopiar } from '../../../../components/ButtonCopy';
import { procesarMensajeConfirmaacion } from '../../../../utils/mensajes_utils';

const ModalServicioAgendado = ({ 
  isOpen, 
  onClose, 
  servicioDataRetornado,
  configuracion,
  clienteData
}) => {
  const [copiados, setCopiados] = useState({
    cliente: false,
    confirmacion: false
  });

  console.log("recibido ",servicioDataRetornado);

  // ✅ DEBUG: Verificar datos recibidos
  useEffect(() => {
    if (isOpen && servicioDataRetornado) {
      console.log("📊 Modal éxito abierto con datos:", servicioDataRetornado);
    }
  }, [isOpen, servicioDataRetornado]);

  // ✅ MANEJAR COPIA EXITOSA
  const handleCopiaExitosa = (tipo) => {
    setCopiados(prev => ({
      ...prev,
      [tipo]: true
    }));
    
    console.log(`✅ ${tipo} copiado exitosamente`);
  };

  // ✅ VERIFICAR SI AMBOS ESTÁN COPIADOS
  const todoCopiado = copiados.cliente && copiados.confirmacion;

  // ✅ CERRAR MODAL
  const handleClose = () => {
    // Resetear estado de copiados
    setCopiados({
      cliente: false,
      confirmacion: false
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      {/* ✅ MODAL MÁS GRANDE - max-w-3xl en lugar de max-w-md */}
      <div className="bg-white rounded-lg shadow-xl w-[65vw] w-full max-h-[90vh] overflow-y-auto">
        
        {/* ✅ HEADER MÁS ESPACIOSO */}
        <div className="flex justify-between items-center p-8 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="text-green-600" size={28} />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">¡Servicio Agendado Exitosamente!</h2>
              <p className="text-lg text-green-600 font-medium mt-1">
                ID: {servicioDataRetornado?.idsolicitud}
              </p>
            </div>
          </div>
          <button
            onClick={handleClose}
            disabled={!todoCopiado}
            className="text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed p-2"
            title={!todoCopiado ? "Debe copiar ambos mensajes antes de cerrar" : "Cerrar"}
          >
            <X size={28} />
          </button>
        </div>

        {/* ✅ CONTENIDO PRINCIPAL MÁS ESPACIOSO */}
        <div className="p-8 space-y-8">
          
          {/* ✅ INFORMACIÓN DEL SERVICIO MÁS GRANDE */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-green-900 mb-4 flex items-center">
              <CheckCircle size={20} className="mr-2" />
              Resumen del Servicio Agendado
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-green-700 font-medium">Tutor:</span>
                  <span className="font-semibold text-green-900 text-lg">{servicioDataRetornado?.tutor}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-green-700 font-medium">Cliente:</span>
                  <span className="font-semibold text-green-900">{clienteData?.nombrecompletoCliente}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-green-700 font-medium">Número:</span>
                  <span className="font-semibold text-green-900">{servicioDataRetornado?.cliente}</span>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-green-700 font-medium">Materia:</span>
                  <span className="font-semibold text-green-900">{servicioDataRetornado?.materia}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-green-700 font-medium">Precio:</span>
                  <span className="font-bold text-green-900 text-lg">
                    ${servicioDataRetornado?.preciocobrado?.toLocaleString() || '0'}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-green-700 font-medium">Ganancia:</span>
                  <span className="font-bold text-green-900 text-lg">
                    ${((servicioDataRetornado?.preciocobrado || 0) - (servicioDataRetornado?.preciotutor || 0)).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ INSTRUCCIONES MÁS GRANDES */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <h4 className="text-lg font-semibold text-blue-900 mb-3 flex items-center">
              📋 Próximos pasos importantes:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">1</div>
                <span className="text-blue-800 font-medium">Copie el mensaje para el cliente</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">2</div>
                <span className="text-blue-800 font-medium">Copie el mensaje de confirmación interna</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">3</div>
                <span className="text-blue-800 font-medium">Envíe los mensajes correspondientes</span>
              </div>
            </div>
          </div>

          {/* ✅ BOTONES DE COPIA MÁS GRANDES */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            
            {/* ✅ BOTÓN COPIAR CLIENTE */}
            <div className={`border-2 rounded-xl p-6 transition-all ${
              copiados.cliente 
                ? 'border-green-300 bg-green-50' 
                : 'border-gray-300 bg-white hover:border-blue-300 hover:shadow-md'
            }`}>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                    copiados.cliente ? 'bg-green-200' : 'bg-blue-100'
                  }`}>
                    <User size={20} className={copiados.cliente ? 'text-green-700' : 'text-blue-600'} />
                  </div>
                  <div>
                    <span className="text-lg font-semibold text-gray-900">Mensaje para Cliente</span>
                    <p className="text-sm text-gray-600">Notificación personalizada</p>
                  </div>
                </div>
                {copiados.cliente && (
                  <Check size={24} className="text-green-600" />
                )}
              </div>
              
              <p className="text-sm text-gray-600 mb-4">
                Mensaje personalizado para enviar al cliente informando sobre el servicio agendado 
                con todos los detalles importantes.
              </p>
              
              <BotonCopiar
                funcionGenerarTexto={() => procesarMensajeConfirmaacion(servicioDataRetornado,configuracion,false,clienteData,true)}
                identificador="mensaje-cliente"
                textoCopiar="Copiar mensaje para cliente"
                textoCopiado="¡Mensaje copiado!"
                className={`w-full justify-center py-3 text-base font-medium ${
                  copiados.cliente 
                    ? 'bg-green-100 text-green-700 border-green-300' 
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
                onSuccess={() => handleCopiaExitosa('cliente')}
              />
            </div>

            {/* ✅ BOTÓN COPIAR CONFIRMACIÓN */}
            <div className={`border-2 rounded-xl p-6 transition-all ${
              copiados.confirmacion 
                ? 'border-green-300 bg-green-50' 
                : 'border-gray-300 bg-white hover:border-gray-400 hover:shadow-md'
            }`}>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                    copiados.confirmacion ? 'bg-green-200' : 'bg-gray-100'
                  }`}>
                    <MessageSquare size={20} className={copiados.confirmacion ? 'text-green-700' : 'text-gray-600'} />
                  </div>
                  <div>
                    <span className="text-lg font-semibold text-gray-900">Confirmación Interna</span>
                    <p className="text-sm text-gray-600">Registro administrativo</p>
                  </div>
                </div>
                {copiados.confirmacion && (
                  <Check size={24} className="text-green-600" />
                )}
              </div>
              
              <p className="text-sm text-gray-600 mb-4">
                Mensaje de confirmación con detalles completos del servicio agendado 
                para registros internos y seguimiento.
              </p>
              
              <BotonCopiar
                funcionGenerarTexto={() => procesarMensajeConfirmaacion(servicioDataRetornado,configuracion,true,clienteData,false)}
                identificador="mensaje-confirmacion"
                textoCopiar="Copiar confirmación interna"
                textoCopiado="¡Confirmación copiada!"
                className={`w-full justify-center py-3 text-base font-medium ${
                  copiados.confirmacion 
                    ? 'bg-green-100 text-green-700 border-green-300' 
                    : 'bg-gray-600 text-white hover:bg-gray-700'
                }`}
                onSuccess={() => handleCopiaExitosa('confirmacion')}
              />
            </div>
          </div>

          {/* ✅ INDICADOR DE PROGRESO MÁS GRANDE */}
          <div className="bg-gray-50 rounded-xl p-6">
            <div className="flex items-center justify-between mb-3">
              <span className="text-lg font-semibold text-gray-700">Progreso de copia</span>
              <div className="flex items-center gap-2">
                <span className="text-lg font-bold text-gray-900">
                  {Object.values(copiados).filter(Boolean).length}/2
                </span>
                <span className="text-sm text-gray-600">completado</span>
              </div>
            </div>
            
            <div className="w-full bg-gray-200 rounded-full h-3 mb-3">
              <div 
                className="bg-green-600 h-3 rounded-full transition-all duration-500"
                style={{ 
                  width: `${(Object.values(copiados).filter(Boolean).length / 2) * 100}%` 
                }}
              ></div>
            </div>
            
            {todoCopiado ? (
              <div className="flex items-center gap-2 text-green-600">
                <CheckCircle size={20} />
                <p className="font-semibold">
                  ✅ Ambos mensajes copiados - Ya puede cerrar el modal
                </p>
              </div>
            ) : (
              <div className="flex items-center gap-2 text-amber-600">
                <AlertTriangle size={20} />
                <p className="font-medium">
                  ⚠️ Copie ambos mensajes antes de cerrar
                </p>
              </div>
            )}
          </div>
        </div>

        {/* ✅ FOOTER MÁS GRANDE */}
        <div className="px-8 py-6 bg-gray-50 border-t border-gray-200">
          <div className="flex justify-between items-center">
            <div className="text-base text-gray-600">
              {!todoCopiado ? (
                <span className="flex items-center gap-2">
                  <AlertTriangle size={18} className="text-amber-500" />
                  Copie ambos mensajes antes de cerrar
                </span>
              ) : (
                <span className="flex items-center gap-2 text-green-600">
                  <CheckCircle size={18} />
                  ¡Listo para cerrar!
                </span>
              )}
            </div>
            
            <button
              onClick={handleClose}
              disabled={!todoCopiado}
              className={`px-8 py-3 rounded-lg font-semibold text-base transition-all ${
                todoCopiado
                  ? 'bg-green-600 text-white hover:bg-green-700 shadow-md hover:shadow-lg'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              {todoCopiado ? 'Cerrar Modal' : 'Copiar mensajes primero'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalServicioAgendado;